import { staticComponentValueConverter } from '../StaticComponentValues';
import { useSelector } from 'react-redux';
function Cart_1({ item }) {
  const customization = staticComponentValueConverter(item?.customization);
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const products = useSelector(state => state.themeSlice.products);
  const firstProduct = products && Object.values(products)?.[0];

  return (
    <>
      <div className="w-full h-full relative flex flex-col">
        <div
          style={{
            display: 'flex',
            padding: staticValues[10],
            gap: 15,
            margin: 10,
            borderRadius: 10,
            borderWidth: 0.5,
            borderStyle: 'solid',
            borderColor: 'var(--secondaryThemeColor)',
            color: 'var(--secondaryThemeColor)',
          }}
        >
          <div style={{ display: 'flex' }}>
            <div>
              <img
                style={{
                  width: 110,
                  height: '100%',
                  borderRadius: 10,
                  objectFit: customization?.backgroundSize,
                }}
                src={firstProduct?.image}
              />
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            <div style={{ textAlign: 'start', display: 'flex', flexDirection: 'column', gap: 5, flex: 1 }}>
              <div style={{ fontSize: 16, fontWeight: 'bold' }}>{firstProduct?.label}</div>
              <div style={{ fontSize: staticValues[10] }}>Adet: 1</div>

              {firstProduct?.data?.productVariantTypes?.map((variantType, index) => (
                <div key={index} style={{ fontSize: staticValues[10] }}>
                  {variantType?.variantType?.name}: {variantType?.variantType?.values?.[0]?.name}
                </div>
              ))}
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 5, alignItems: 'start' }}>
                <div style={{ fontSize: staticValues[10], textDecoration: 'line-through' }}>
                  ₺{(firstProduct?.data?.variants?.[0]?.prices[0]?.sellPrice * 1.01)?.toFixed(2)}
                </div>
                <div style={{ fontSize: staticValues[10], fontWeight: 'bold' }}>
                  ₺{(firstProduct?.data?.variants?.[0]?.prices[0]?.sellPrice * 0.9)?.toFixed(2)}
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  width: 'max-content',
                  alignItems: 'center',
                  backgroundColor: 'var(--thirdThemeColor)',
                  borderRadius: 10,
                  fontSize: staticValues[10],
                }}
              >
                <div
                  style={{
                    padding: '0px 8px',
                    borderRadius: 5,
                    height: 35,
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: 'var(--thirdThemeColor)',
                    color: 'var(--fourthThemeColor)',
                  }}
                >
                  -
                </div>
                <div
                  style={{
                    padding: '0px 8px',
                    borderRadius: 5,
                    height: 35,
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: 'var(--thirdThemeColor)',
                    color: 'var(--fourthThemeColor)',
                  }}
                >
                  1
                </div>
                <div
                  style={{
                    padding: '0px 8px',
                    borderRadius: 5,
                    height: 35,
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: 'var(--thirdThemeColor)',
                    color: 'var(--fourthThemeColor)',
                  }}
                >
                  +
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Cart_1;
